import { observer } from 'mobx-react';
import { LicenseFamily } from '../../../../Organization/Types';
import ParticipantsStore from '../../../../ParticipantsStore';
import Skeleton from '../Skeleton';
import View from '../View';

interface Props {
  participantsStore: ParticipantsStore;
  licenseFamily: LicenseFamily;
}

function ParticipantsState({ participantsStore, licenseFamily }: Props) {
  switch (participantsStore.state.kind) {
    case 'initializing':
    case 'loading':
    case 'loading-more':
      return <Skeleton filterCount={7} tableColCount={8} checkBoxRequirement="required" />;
    case 'ready':
    case 'updating-query':
    case 'updating-search-parameters':
    case 'sorting':
      return (
        <View
          participantsStore={participantsStore}
          participantStores={participantsStore.state.participantStores}
          selectedOrganization={participantsStore.state.selectedOrganization}
          participantsState={participantsStore.state}
          licenseFamily={licenseFamily}
        />
      );
    case 'error':
      return <></>;
  }
}

export default observer(ParticipantsState);
